module.exports = __webpack_public_path__ + "img/vue2-corpsavant_lavande.8c3bd3e2.png";